// extracted by mini-css-extract-plugin
module.exports = {"md":"feedback-sheet-external_md_31KV7","ios":"feedback-sheet-external_ios_iDSo0","sheet":"feedback-sheet-external_sheet_1pBEg","handler":"feedback-sheet-external_handler_3gl16"};